<template>
  <Transition name="fade">
    <div v-if="store.isOpen" class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden transform transition-all scale-100 border-t-8"
           :class="store.type === 'success' ? 'border-[#b0d23c]' : 'border-red-500'">

        <div class="p-8 text-center">
          <div v-if="store.type === 'success'" class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
            <span class="text-3xl text-green-600">✓</span>
          </div>
          <div v-else class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
            <span class="text-3xl text-red-600">✕</span>
          </div>

          <h3 class="text-xl font-black text-[#163271] uppercase tracking-tighter mb-2">
            {{ store.type === 'success' ? 'Succès' : 'Attention' }}
          </h3>
          <p class="text-gray-600 font-bold text-sm">{{ store.message }}</p>

          <button @click="store.close()"
                  class="mt-8 w-full py-3 px-6 bg-[#163271] text-white rounded-xl font-black uppercase text-xs tracking-widest hover:bg-[#b0d23c] hover:text-[#163271] transition-all">
            Continuer
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useNotificationStore } from '@/stores/notification';
const store = useNotificationStore();
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease, transform 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: scale(0.9); }
</style>